var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 29,
    viewBox: "0 0 16 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M12.452 6.406v-.55c0-.487-.394-.882-.88-.882-.488 0-.882.395-.882.881v.497l-.524-.002v-.959c0-.548-.444-.993-.993-.993-.548 0-.993.445-.993.993v.951l-4.835-.02V1.08C3.345.483 2.863 0 2.267 0c-.596 0-1.079.483-1.079 1.08v5.474c0 .005.004.01.004.015C.489 6.93 0 7.654 0 8.494V25.56c0 1.194.977 2.17 2.173 2.17h9.738c1.195 0 2.172-.976 2.172-2.17V8.494c0-1.006-.698-1.845-1.63-2.088",
    transform: "translate(.445 .138)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303BA6",
    d: "M3.147 11.37c-.675 0-1.223-.547-1.223-1.222 0-.676.548-1.224 1.223-1.224h7.79c.675 0 1.223.548 1.223 1.224 0 .675-.548 1.222-1.223 1.222h-7.79z",
    transform: "translate(.445 .138)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.4b69e329ed6ef94b96d176c8992dc75e.svg";
export { ForwardRef as ReactComponent };